import { GraphConfiguration } from "@/type/common";
import { v4 as uuidv4 } from "uuid";

export const getDefaultConfig = (
  type: "graph" | "table" | "block"
): GraphConfiguration => {
  const now = new Date().toISOString();

  return {
    id: type.slice(0, 1).toUpperCase() + type.slice(1) + `-${uuidv4()}`,
    title: "",
    description: "",
    model: "",
    type,
    view_options: {
      fullScreenEnabled: true,
      refreshInterval: null,
      autoRefresh: false,
    },
    data_source: {
      domain: [],
      groupBy: [],
      orderBy: {
        field: "",
        direction: "asc",
      },
    },
    graph_options: {
      chartType: "bar",
      stacked: false,
      barOverlay: false,
      animation: true,
      colors: ["#3B82F6", "#10B981", "#F59E0B", "#EF4444", "#8B5CF6"],
      showGrid: true,
      showRecordCount: true,
      xAxis: {
        title: "",
        field: "",
        showAxis: true,
        format: "default",
        tickRotation: 0,
      },
      yAxis: {
        left: {
          title: "",
          showAxis: true,
          format: "default",
          min: null,
          max: null,
        },
        right: {
          title: "",
          showAxis: false,
          format: "default",
          min: null,
          max: null,
        },
      },
      legend: {
        show: true,
        position: "bottom",
        clickable: true,
      },
      pieLabels: {
        show: true,
        type: "percentage",
      },
      measures: [],
      only_count: false,
      thresholds: [],
      referenceAreas: [],
      theme: "default",
    },
    table_options: {
      columns: [],
      pageSize: 20,
      pagination: true,
      totalsRow: false,
      styling: {
        striped: true,
        highlightHover: true,
        theme: "default",
      },
    },
    block_options: {
      field: "",
      aggregation: "sum",
      size: "medium",
      prefix: "",
      suffix: "",
      format: "number",
      decimals: 0,
      icon: "",
      only_count: false,
    },
    createdAt: now,
    updatedAt: now,
  };
};
